import { Visibility, VisibilityOff } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Grid,
  IconButton,
  InputAdornment,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { FormProvider } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import TextInput from "src/qubCommon/Inputs/TextInput";
import gsisLogo from "src/assets/images/gsis_logo.png";

const LoginBox = (props) => {
  const { loginForm, handleLogin } = props;

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async () => {
    setLoading(true);
    await handleLogin();
    setLoading(false);
  };

  return (
    <div
      style={{
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ background: "#003375", padding: 22, borderRadius: 20 }}>
        <Grid item xs={12} mb={2}>
          <Typography
            align="center"
            style={{
              color: "#f1f1f1",
              fontWeight: 200,
              marginBottom: 12,
              fontSize: "1.4rem",
            }}
          >
            Σύνδεση Χρήστη με κωδικούς TaxisNet
          </Typography>
          <hr style={{ color: "#f1f1f1" }} />
        </Grid>
        <Grid item xs={12} mb={2}>
          <img src={gsisLogo} alt="gsis-logo" />
        </Grid>
        <Grid item xs={12}>
          <LoadingButton
            color="secondary"
            variant="contained"
            loading={loading}
            sx={{
              width: "100%",
              color: "#fefefe",
              fontWeight: 600,
            }}
            onClick={() =>
              window.location.replace(
                `${import.meta.env.VITE_REACT_APP_BASE_URL}/auth/gogsis`
              )
            }
          >
            Συνέχεια στο TaxisNet
          </LoadingButton>
        </Grid>
      </div>
    </div>
  );
};

export default LoginBox;
